import { Field } from "formik";
import { TGenericGUIDName } from "../../lib/types/general";

type TRegionsCheckListProps = {
    regions: TGenericGUIDName[];
    masterKey: string;
};

type TRegionsCheckListNoFormikProps = {
    regions: TGenericGUIDName[];
    checkedList: {
        [key: string]: boolean;
    };
    refs: {
        current: {
            [keys: string]: boolean;
        };
    };
    masterKey: string;
};

/**
 * To be found in sign up forms
 * @param props
 * @returns
 */
export const RegionsCheckList = (props: TRegionsCheckListProps) => {
    const { regions, masterKey } = props;

    return (
        <>
            {regions.map((region) => {
                return (
                    <div
                        className="col-lg-4 pb-2"
                        key={`region_${masterKey}_${region.guid}`}
                    >
                        <div className="form-check">
                            <label className="form-control-label ms-2">
                                <Field
                                    name={"desiredRegion"}
                                    type="checkbox"
                                    data-testid="region_techSignUp_formik_checkbox"
                                    className="form-check-input"
                                    value={region.guid}
                                />
                                {region.name}
                            </label>
                        </div>
                    </div>
                );
            })}
        </>
    );
};

/**
 * Used in dental-tech-info.
 * As a lab in My Account you can edit the regions you are interested in.
 * @param props
 * @returns
 */
export const RegionsCheckListNoFormik = (
    props: TRegionsCheckListNoFormikProps
) => {
    const { regions, checkedList, refs, masterKey } = props;

    return (
        <>
            {regions.map((reg) => {
                return (
                    <div key={`region_${masterKey}_${reg.guid}`}>
                        <div className="input-group pb-2">
                            <div className="">
                                <label className="form-label">
                                    <input
                                        type="checkbox"
                                        defaultChecked={checkedList[reg.guid]}
                                        data-testid="checkbox-value-no-formik"
                                        className="form-check-input mx-2"
                                        onChange={(e) => {
                                            refs.current[reg.guid] =
                                                e.target.checked;
                                        }}
                                    />
                                    {reg.name}
                                </label>
                            </div>
                        </div>
                    </div>
                );
            })}
        </>
    );
};
